export default class Hero {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;

        if (typeof window.globalVolumeStatus === 'undefined') {
            window.globalVolumeStatus = false;
        }

        this.init();
    }

    init() {
        const volumeControler = this.el.querySelector('#hero-volume');
        const volumeText = volumeControler ? volumeControler.querySelector('.hero__volume-text') : null;
        const videos = [...this.el.querySelectorAll('.hero__background video')];

        if (!volumeControler || !volumeText || !videos.length) return;

        const getActiveVideo = () => videos.find(v => v.offsetParent !== null);

        let isVolumeOn = false;

        const updateUI = () => {
            if (isVolumeOn) {
                volumeControler.classList.add('volume-on');
                volumeControler.classList.remove('volume-off');
                volumeText.textContent = 'ON';
            } else {
                volumeControler.classList.add('volume-off');
                volumeControler.classList.remove('volume-on');
                volumeText.textContent = 'OFF';
            }
        };

        const applyVolume = () => {
            const active = getActiveVideo();

            videos.forEach((video) => {
                if (video === active) {
                    video.muted = !isVolumeOn;
                    if (isVolumeOn) video.volume = 0.5;
                    video.play().catch(() => {});
                } else {
                    video.muted = true;
                    video.pause();
                    video.currentTime = 0;
                }
            });
        };

        volumeControler.addEventListener('click', () => {
            isVolumeOn = !isVolumeOn;
            applyVolume();
            updateUI();
        });

        updateUI();
        applyVolume();

        window.addEventListener('resize', () => {
            applyVolume();
        });
    }
}
